exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%;\n  width: 100%;\n  overflow: hidden; }\n\n.info-header-cell {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  min-width: 0;\n  cursor: pointer; }\n\n.info-header-label {\n  -ms-flex: 1;\n      flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.info-header-icon {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  cursor: pointer;\n  color: #fff;\n  opacity: .85; }\n\n.info-header-icon:hover {\n  opacity: 1; }\n\n.info-header-icon-static {\n  cursor: help; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/info-header/info-header.component.scss
// module id = 1911
// module chunks = 66